import { render, staticRenderFns } from "./TypesTickets.vue?vue&type=template&id=5ae40163&scoped=true"
import script from "./TypesTickets.vue?vue&type=script&lang=js"
export * from "./TypesTickets.vue?vue&type=script&lang=js"
import style0 from "./TypesTickets.vue?vue&type=style&index=0&id=5ae40163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae40163",
  null
  
)

export default component.exports